(() => {
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };
  function labelInput(input, text) {
    const label = input.closest('.chiq-upload').querySelector(`label[for="${CSS.escape(input.id)}"]`);
    if (!label) return;
    label.replaceChildren(document.createTextNode(text + ' '));
    if (input.required || input.name === 'productPhoto') label.append(node('span', 'chiq-evidence-required', '*'));
    return label;
  }
  function fileState(input, help) {
    const status = node('p', 'chiq-evidence-file');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    const remove = node('button', 'chiq-evidence-remove', 'Remove file');
    remove.type = 'button';
    remove.hidden = true;
    input.after(status, remove);
    input.classList.add('chiq-evidence-input');
    help.id = input.id + '-evidence-help';
    input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), help.id].filter(Boolean).join(' '));
    function update() {
      const file = input.files?.[0];
      status.textContent = file ? `${file.name} · ${file.size < 1048576 ? `${Math.max(1, Math.round(file.size / 1024))} KB` : `${(file.size / 1048576).toFixed(1)} MB`} selected` : 'No file selected';
      status.classList.toggle('is-selected', Boolean(file));
      remove.hidden = !file;
      remove.setAttribute('aria-label', file ? `Remove ${file.name}` : 'Remove file');
    }
    remove.addEventListener('click', () => {
      input.value = '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus();
    });
    input.addEventListener('change', update);
    input.form?.addEventListener('reset', () => setTimeout(update, 0));
    update();
  }
  function updateReviewPeriod(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let text;
    while ((text = walker.nextNode())) {
      const updated = text.nodeValue.replace(/5 business days/g, '10 business days');
      if (updated !== text.nodeValue) text.nodeValue = updated;
    }
  }
  function enhance(form) {
    document.querySelectorAll(".chiq-registration-context small").forEach(updateReviewPeriod);
    const mobile = form.querySelector('[name="phone"]');
    if (mobile) {
      mobile.required = true;
      const label = form.querySelector(`label[for="${CSS.escape(mobile.id)}"]`);
      if (label) { label.replaceChildren(document.createTextNode('Mobile '), node('span', '', '*')); }
      mobile.setAttribute('inputmode', 'tel');
      mobile.setAttribute('aria-required', 'true');
      if (!form.querySelector('[name="mobileRequired"]')) {
        const marker = node('input'); marker.type = 'hidden'; marker.name = 'mobileRequired'; marker.value = 'true'; form.append(marker);
      }
    }
    const intro = form.closest('.chiq-warranty')?.querySelector('.chiq-warranty__header');
    if (intro && !intro.dataset.deliveryGuidance) { intro.append(node('p', '', 'Apply after your product has been delivered or installed.')); intro.dataset.deliveryGuidance = 'true'; }
    form.closest('.chiq-warranty')?.querySelectorAll('.chiq-warranty__footnote, [data-success] p, .chiq-warranty__success p').forEach(updateReviewPeriod);

    const receipt = form.querySelector('input[name="receipt"]');
    const photo = form.querySelector('input[name="productPhoto"]');
    if (!receipt || !photo) return;
    const receiptCard = receipt.closest('.chiq-upload');
    const photoCard = photo.closest('.chiq-upload');
    if (!receiptCard || !photoCard || receiptCard.dataset.evidenceReady) return;
    receiptCard.dataset.evidenceReady = 'true';
    const productLimit = form.querySelector('.chiq-products__actions small');
    if (productLimit) {
      productLimit.textContent = 'Maximum three products per receipt. More than three products? Submit another registration for the remaining products.';
      productLimit.classList.add('chiq-products-limit');
      const extraRows = Array.from(form.querySelectorAll('[data-product-entry="2"], [data-product-entry="3"]'));
      const moveLimit = () => {
        const row = extraRows.find(entry => !entry.hidden) || extraRows[0];
        if (row && productLimit.parentElement !== row) row.append(productLimit);
      };
      form.addEventListener('click', moveLimit);
      moveLimit();
    }
    const retailer = form.querySelector('select[name="retailer"]');
    if (retailer && !Array.from(retailer.options).some(option => option.value === 'Bi-Rite')) {
      const biRite = node('option', '', 'Bi-Rite');
      biRite.value = 'Bi-Rite';
      const before = Array.from(retailer.options).find(option => option.value === 'Harvey Norman');
      retailer.insertBefore(biRite, before || retailer.lastElementChild);
    }
    const first = form.querySelector('input[name="firstName"]');
    const last = form.querySelector('input[name="lastName"]');
    if (first && last) {
      const initialName = [first.value, last.value].filter(Boolean).join(' ');
      const firstField = first.closest('.chiq-field');
      firstField.classList.add('chiq-field--wide');
      const label = firstField.querySelector('label');
      label.replaceChildren(document.createTextNode('Full name '), node('span', 'chiq-evidence-required', '*'));
      first.name = 'fullName';
      first.autocomplete = 'name';
      first.maxLength = 160;
      first.value = initialName;
      const firstError = firstField.querySelector('[data-error-for]');
      if (firstError) firstError.dataset.errorFor = 'fullName';
      const storedFirst = node('input');
      storedFirst.type = 'hidden';
      storedFirst.name = 'firstName';
      first.after(storedFirst);
      last.required = false;
      last.type = 'hidden';
      last.closest('.chiq-field').hidden = true;
      const syncName = () => {
        const name = first.value.trim().replace(/\s+/g, ' ');
        const parts = name.split(' ');
        storedFirst.value = parts.shift() || '';
        last.value = parts.join(' ');
        first.setCustomValidity(name.length < 2 ? 'Enter your full name.' : '');
      };
      first.addEventListener('input', syncName);
      form.addEventListener('submit', syncName, true);
      form.addEventListener('reset', () => setTimeout(syncName, 0));
      syncName();
    }
    const serial = form.querySelector('input[name="serialNumber"]');
    const serialHelp = form.querySelector('[data-serial-help]') || serial?.closest('.chiq-field')?.querySelector('small');
    if (serial && serialHelp) {
      const text = 'Enter the serial number exactly as shown on your product.';
      const encourageSerial = () => { if (serialHelp.textContent !== text) serialHelp.textContent = text; };
      encourageSerial();
      new MutationObserver(encourageSerial).observe(serialHelp, { childList: true, characterData: true, subtree: true });
      const field = serial.closest('.chiq-field');
      const requiredMark = node('span', 'chiq-evidence-required', ' *');
      field.querySelector(`label[for="${CSS.escape(serial.id)}"]`)?.append(requiredMark);
      let help = field.querySelector('details');
      if (!help) {
        help = node('details', 'chiq-serial-help');
        help.append(node('summary', '', 'Can’t find your serial number?'));
      }
      help.classList.add('chiq-serial-help');
      const summary = help.querySelector('summary');
      summary.setAttribute('aria-label', 'Can’t find your serial number?');
      const toggleLabel = summary.querySelector('.chiq-help__toggle-label');
      if (toggleLabel) toggleLabel.textContent = 'Can’t find your serial number?';
      serialHelp.after(help);
      const fallbackLabel = node('label', 'chiq-serial-fallback');
      const fallback = node('input');
      fallback.type = 'checkbox';
      fallback.id = serial.id + '-unavailable';
      fallbackLabel.append(fallback, node('span', '', 'I can’t locate or access the serial number'));
      const fallbackHelp = node('p', 'chiq-serial-fallback-help', 'Upload a clear photo of the installed product in the Proof of purchase section below. Your receipt is still required.');
      summary.after(fallbackLabel, fallbackHelp);
      const guideNote = help.querySelector('.chiq-help__popup > small');
      if (guideNote) guideNote.textContent = 'Look for “S/N” or “Serial No.” on the label.';
      let retainedSerial = '';
      const syncSerial = () => {
        const usePhoto = fallback.checked;
        if (usePhoto && !serial.disabled) {
          retainedSerial = serial.value;
          serial.value = '';
        } else if (!usePhoto && serial.disabled) {
          serial.value = retainedSerial;
          retainedSerial = '';
        }
        serial.disabled = usePhoto;
        requiredMark.hidden = usePhoto;
        if (serial.required !== !usePhoto) serial.required = !usePhoto;
        if (photo.required !== usePhoto) photo.required = usePhoto;
        if (photoCard.hidden !== !usePhoto) photoCard.hidden = !usePhoto;
      };
      // Run after the app's model/serial handlers without replacing them.
      for (const event of ['input', 'change', 'click', 'focusout']) form.addEventListener(event, syncSerial);
      fallback.addEventListener('change', syncSerial);
      form.addEventListener('reset', () => setTimeout(() => { retainedSerial = ''; syncSerial(); }, 0));
      new MutationObserver(syncSerial).observe(photoCard, { attributes: true, attributeFilter: ['hidden'] });
      new MutationObserver(syncSerial).observe(serial, { attributes: true, attributeFilter: ['required'] });
      syncSerial();
    }
    let fieldset = receipt.closest('fieldset');
    if (!fieldset) {
      fieldset = node('fieldset');
      fieldset.append(node('legend', '', 'Proof of purchase'));
      photoCard.before(fieldset);
      fieldset.append(photoCard, receiptCard);
    }
    fieldset.classList.add('chiq-evidence');
    receiptCard.classList.add('chiq-evidence-card');
    photoCard.classList.add('chiq-evidence-card', 'chiq-evidence-photo');
    fieldset.insertBefore(receiptCard, photoCard);
    labelInput(receipt, 'Tax invoice or receipt');
    const receiptHelp = receiptCard.querySelector('small');
    receiptHelp.textContent = 'Upload a clear, readable copy showing:';
    const checklist = node('ul', 'chiq-evidence-checklist');
    for (const text of ['Model number', 'Order date', 'Retailer details', 'Your name']) checklist.append(node('li', '', text));
    receiptHelp.after(checklist);
    const formats = node('p', 'chiq-evidence-formats', 'JPG / JPEG, PNG, HEIC, HEIF or PDF · Up to 10 MB');
    checklist.after(formats);
    receiptCard.insertBefore(receiptHelp, receipt);
    receiptCard.insertBefore(checklist, receipt);
    receiptCard.insertBefore(formats, receipt);
    fileState(receipt, formats);
    const second = form.querySelector('input[name="receiptPart2"]');
    if (second) {
      const secondLabel = receiptCard.querySelector(`label[for="${CSS.escape(second.id)}"]`);
      const secondHelp = second.nextElementSibling?.tagName === 'SMALL' ? second.nextElementSibling : node('small');
      const extra = node('details', 'chiq-evidence-extra');
      const summary = node('summary', '', 'Add a second PDF (optional)');
      secondLabel.textContent = 'Second receipt PDF';
      secondHelp.textContent = 'For a two-part invoice, select both parts as PDFs. Up to 10 MB per file.';
      extra.append(summary, secondLabel, secondHelp, second);
      receiptCard.append(extra);
      fileState(second, secondHelp);
      second.addEventListener('change', () => { if (second.files?.length) extra.open = true; });
    }
    labelInput(photo, 'Installed product photo');
    const photoHelp = photoCard.querySelector('small');
    photoHelp.textContent = 'If the serial number is physically inaccessible, upload a clear photo of the installed product. Your receipt is still required.';
    photoCard.insertBefore(photoHelp, photo);
    const photoFormats = node('p', 'chiq-evidence-formats', 'JPG / JPEG, PNG, HEIC or HEIF · Up to 10 MB');
    photoCard.insertBefore(photoFormats, photo);
    fileState(photo, photoFormats);
  }
  const refresh = () => document.querySelectorAll('.chiq-warranty form').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
})();
